import { Menu, type MenuGroupProps, Text } from "@overmap-ai/blocks"
import type { User } from "@overmap-ai/common"
import { memo } from "react"

import { getUserDisplayLabel } from "../../utils/users"
import { UserIcon } from "../Icons/UserIcon"

export interface UserGroupProps extends MenuGroupProps {
	users: User[]
	onSelectUser: (user: User) => void
}

export const UserGroup = memo<UserGroupProps>((props) => {
	const { ref, users, onSelectUser, ...rest } = props

	return (
		<Menu.Group ref={ref} {...rest}>
			{users.map((user) => {
				return (
					<Menu.Item key={user.id} onSelect={() => onSelectUser(user)} className="truncate">
						<UserIcon userId={user?.id} size="xs" />
						<Text className="truncate">{getUserDisplayLabel(user)}</Text>
					</Menu.Item>
				)
			})}
		</Menu.Group>
	)
})
UserGroup.displayName = "UserGroup"
